import RandomColor from "randomcolor"
import vuetifyToast from 'vuetify-toast'

export class Helpers {
  
    public static getRandomColorWithSeed(
            seed, 
            luminosity: "bright" | "light" | "dark" | "random" = "bright"): string {
        const randomSeededNumber = Math.floor(Math.sin(seed) * 10000);
        // RandomColor returns random colors indeed, but it's seed must have variable for the color to have variance
        return RandomColor({ seed: randomSeededNumber.toString(), luminosity });
    }

    public static todoToast() {
        vuetifyToast.error('This feature is not yet available');
    }

    public static nameFromEmail(email: string): string {
        try {
            return email
            .split('@')[0]
            .split('.')
            .map(x => x.charAt(0).toUpperCase() + x.substr(1))
            .join(' ');
        } catch (err) {
            return email ? email : '';
        }
    }
}

export default Helpers;
